module.exports = __webpack_public_path__ + "static/media/slider-3.9cb07e04.png";